module.exports = __webpack_public_path__ + "static/media/gumDisease.c7426747.svg";